var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H15C15.2833 18 15.521 17.904 15.713 17.712C15.9043 17.5207 16 17.2833 16 17C16 16.7167 15.9043 16.4793 15.713 16.288C15.521 16.096 15.2833 16 15 16H9C8.71667 16 8.47933 16.096 8.288 16.288C8.096 16.4793 8 16.7167 8 17C8 17.2833 8.096 17.5207 8.288 17.712C8.47933 17.904 8.71667 18 9 18ZM9 14H15C15.2833 14 15.521 13.904 15.713 13.712C15.9043 13.5207 16 13.2833 16 13C16 12.7167 15.9043 12.479 15.713 12.287C15.521 12.0957 15.2833 12 15 12H9C8.71667 12 8.47933 12.0957 8.288 12.287C8.096 12.479 8 12.7167 8 13C8 13.2833 8.096 13.5207 8.288 13.712C8.47933 13.904 8.71667 14 9 14ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.196 21.021 4 20.55 4 20V4C4 3.45 4.196 2.979 4.588 2.587C4.97933 2.19567 5.45 2 6 2H13.175C13.4417 2 13.696 2.05 13.938 2.15C14.1793 2.25 14.3917 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.82067 19.85 8.062C19.95 8.304 20 8.55833 20 8.825V20C20 20.55 19.8043 21.021 19.413 21.413C19.021 21.8043 18.55 22 18 22H6ZM13 8V4H6V20H18V9H14C13.7167 9 13.4793 8.904 13.288 8.712C13.096 8.52067 13 8.28333 13 8ZM6 4V9V4V20V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutline);
export default __webpack_public_path__ + "static/media/Document_Outline.300b1642b394b50bd5eab8bf5232e7f6.svg";
export { ForwardRef as ReactComponent };